import React from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { thousandSeparator } from "utils"
import classes from "./PoOrderCombo.module.scss"

const PoOrderCombo = props => {
  const { orderCombo } = props

  const i18n = useTranslation()[1]

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["card"]}>
      <div className={classes["row"]}>
        <div className={classes["details"]}>
          <div className={classes["title"]}>
            {orderCombo.name}
          </div>
          {orderCombo.items.map((comboItem, ciIndex) =>
            <div
              key={ciIndex}
              className={classes["comboItem"]}
            >
              <div className={classes["comboItemName"]}>
                {comboItem.foodName}{"   "}
                <b>{comboItem.quantity}x</b>
              </div>
              {
                !comboItem.isSimple &&
                <div className={classes["comboItemOptionName"]}>
                  ({comboItem.optionName})
                </div>
              }
            </div>
          )}
        </div>
      </div>
      <div className={classes["right"]}>
        <div
          className={clsx(
            classes["price"],
            isLtr && classes["price-ltr"]
          )}
        >
          {thousandSeparator(orderCombo.comboSetSalePrice)}
        </div>
      </div>
    </div>
  )
}

export default React.memo(PoOrderCombo)